<div class="row">
  <div class="col-6">
    <p class="portal-top-text float-left">
      View health and liveliness of services across platform.
    </p>
  </div>
  <div class="col-6">
    <span class="portal-top-text float-right">
      <a class="mr-3" (click)="refresh()" style="cursor: pointer;" target="_blank" title="Refresh">
        <img src="assets/images/JMicons/JM-icon-19.png" alt="">
      </a>
    </span>
  </div>
</div>

<div class="pr-3 pl-3">
  @if (apiList) {
    <div class="row">
      @for (api of apiList; track api) {
        <div class="col-12 col-md-6 col-lg-4 col-xl-3">
          <div class="checkup-summary position-relative">
            <div>
              <div class="title">
                <img [src]="api.imagePath" alt="icon" class="icon">
                <span>{{ api.name }}</span>
              </div>
            </div>
            <div class="position-relative">
              <div class="status">
                <div class="d-flex justify-content-between" [ngClass]="{ 'flex-row-reverse': !api.url }">
                  @if (api.url) {
                    <div class="options refresh position-relative" (click)="onRefresh(api)"
                      matTooltip="Refresh status" matTooltipPosition="above" matTooltipClass="quartz-tooltip">
                      @if (api.status === HealthCheckApiStatus.Healthy) {
                        <img src="assets/images/JMicons/JM-icon-17.png"
                          alt="icon">
                      }
                      @if (api.status !== HealthCheckApiStatus.Healthy && api.status !== HealthCheckApiStatus.Checking) {
                        <img
                          src="assets/images/JMicons/JM-icon-18.png" alt="icon">
                        }
                        @if (api.status !== HealthCheckApiStatus.Checking) {
                          <span>{{ api.status }}</span>
                        }
                        <app-in-progress [loading]="api.status === HealthCheckApiStatus.Checking"
                        [small]="true"></app-in-progress>
                      </div>
                    }
                    <div class="options">
                      @if (isLogVisible()) {
                        <a class="health-link mr-3" [routerLink]="getHealthCheckDetailsLink(api.name)">
                          <img src="assets/images/JMicons/info_outline.png" alt="">
                        </a>
                      }
                      <!-- // Hide Swagger UI since we are exposing APIs via API Management -->
                      <!-- <a class="mr-3" [href]="api.swaggerLink" target="_blank" title="Swagger">
                      <img src="assets/images/JMicons/swagger_icon.png" alt="">
                    </a> -->
                    @if (isLogVisible() && api.name !== 'Auction') {
                      <a class="mr-3" [routerLink]="getLogsLink(api.name)">
                        <img src="assets/images/JMicons/logs_icon.png" alt="">
                      </a>
                    }
                    @if (configurable(api.name)) {
                      <span class="cursor-pointer" (click)="toggleSectionVisibility(api.name)"
                        [matTooltip]="getConfigureTooltipText(api.name)" matTooltipPosition="above"
                        matTooltipClass="quartz-tooltip">
                        @if (visibleSection?.visibility && api.name === visibleSection.name) {
                          <img
                            src="assets/images/JMicons/settings_toggle_on.png" alt="">
                          } @else {
                            <img src="assets/images/JMicons/settings_toggle_off.png" alt="">
                          }
                        </span>
                      }
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        }
      </div>
    }
  </div>